<template>
    <div class="container-fluid">
        <div class="row mt-3">
                <span class="mt-2 mr-2"> Dzień: </span>
                <datepicker
                    class="mt-1"
                    v-model="startDate"
                    :monday-first="true"
                    :language="lang"
                ></datepicker>
        </div>
        <div v-if="items.length === 0" class="row">
            Brak danych dla wybranego dnia.
        </div>
        <div v-if="items.length" class="row">
            <revision-popup
                title="Korekta"
            />
            <table class="table table-sm table-striped mt-4">
                <thead>
                    <tr>
                        <th scope="col">
                            Data
                        </th>
                        <th scope="col">
                            Model
                        </th>
                        <th scope="col">
                            Produkt
                        </th>
                        <th scope="col">
                            Kolor
                        </th>
                        <th scope="col">
                            Kategoria
                        </th>
                        <th scope="col">
                            Cena
                        </th>
                        <th scope="col">
                            Użytkownik
                        </th>
                        <th scope="col">
                            Komentarz
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in items" :key="item.id" >
                        <td :class="determineRowClass(item)">
                            {{ displayDate(item.eventDate) }}
                            <i
                                class="material-icons pointer-cursor-edit-name"
                                @click="openEditPopup(item, $event)"
                                v-if="canEdit(item)"
                                >
                            create
                            </i>
                        </td>
                        <td :class="determineRowClass(item)"> {{ item.productBrand}} </td>
                        <td :class="determineRowClass(item)"> {{ item.productName}} </td>
                        <td :class="determineRowClass(item)"> {{ item.productColor}} </td>
                        <td :class="determineRowClass(item)"> {{ item.productCategory}} </td>
                        <td :class="determineRowClass(item)" v-html="printPrice(item)"></td>
                        <td :class="determineRowClass(item)"> {{ item.user}} </td>
                        <td :class="determineRowClass(item)" v-html="printComment(item)"></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-if="items.length" class="row">
            Razem: {{ totalTurnover }} zł
        </div>
    </div>
</template>
<script>
import userService from '@/service/userService'
import axios from 'axios'
import appConfig from '@/service/config'
import moment from 'moment'
import MainPresenter from "@/service/MainPresenter"
import datepicker from 'vuejs-datepicker';
import un from 'underscore'
import {pl} from 'vuejs-datepicker/dist/locale'
import VueTimepicker from 'vue2-timepicker'
import revisionPopup from "@/components/daily/RevisionPopup"
import Vue from 'vue'
Vue.component('revision-popup', revisionPopup)

export default {
    components: {
      datepicker,
      VueTimepicker
    },
    data: () => ({
        mainPresenter: new MainPresenter(),
        lang: pl,
        selectedStore: "",
        items: [],
        totalTurnover: 0,
        startDate: moment().format("YYYY-MM-DD"),
        currentStore: {},
        storeId: userService.getCurrentStore()
    }),
    watch: {
        startDate(newVal, oldVal) {
            this.fetchDailyTurnover(newVal, this.onDataLoaded)
        }
    },
    created() {
        this.$eventHub.$on('revisionSaved', this.onRevisionSaved);
    },
    destroyed() {
        this.$eventHub.$off('revisionSaved');
    },
    mounted() {
        this.fetchDailyTurnover(this.startDate, this.onDataLoaded);
        this.loadStores();
    },
    methods: {
        onRevisionSaved(payload){
            const revision = payload.data
            const newItems = []
            for (var i in this.items) {
                var it = this.items[i]
                if (it.id === revision.quantityChangeId) {
                    it.revision = {
                        "revisionId": revision.revisionId,
                        "oldPrice": revision.oldPrice,
                        "newPrice": revision.newPrice,
                        "description": revision.description
                    }
                }
                newItems.push(it)
            }
            this.fetchDailyTurnover(this.startDate, (res) => {
                this.totalTurnover = res.data.totalTurnover
            });
        },
        determineRowClass(item) {
            return item.revision ? "red-font" : ""
        },
        printPrice(item) {
            if (!item.revision)
                return item.price + " zł"
            return `<del>${item.revision.oldPrice}</del> ${item.revision.newPrice} zł`
        },
        printComment(item) {
            if (!item.revision)
                return ""
            return item.revision.description
        },
        loadStores() {
            axios.get(this.mainPresenter.buildUrlWithDefaults("/allStores")).then(response => {
                const store = un.find(response.data.content, (item) => {
                    return item.id == userService.getCurrentStore()
                });
                this.currentStore = {
                    id: store.id,
                    name: store.name,
                }
            }, err => {
                console.log(err.response);
            })
        },
        canEdit(item) {
            return userService.getCurrentUser().name === item.user
        },
        openEditPopup(item, event) {
            const rect = event.target.parentNode.getBoundingClientRect()
            this.$eventHub.$emit("openRevisionPopup", {
                currentStore: this.currentStore,
                item: item,
                rect: rect
            });
        },
        displayDate(date) {
            return moment(date).format('HH:mm:ss YYYY-MM-DD')
        },
        formatDate(date) {
            return moment(date).format('YYYY-MM-DD')
                + "T00:00:00"
        },
        addOneDay(date) {
            return moment(date).add(1,'days').startOf('day')
        },
        prepareData(date) {
            let start = this.formatDate(date)
            let stop = this.formatDate(this.addOneDay(date))
            return {
                "storeId": this.storeId,
                "timeSpan": {
                    "start": start,
                    "stop": stop
                }
            }
        },
        onDataLoaded(res) {
            this.items = res.data.items
            for (var i in this.items) {
                var it = this.items[i]
                it.revision = un.find(res.data.revisions, (rev) => {
                    return rev.quantityChangeId === it.id
                }) || 0
            }
            this.totalTurnover = res.data.totalTurnover
        },
        fetchDailyTurnover(momentDate, onDataLoaded) {
            let data = this.prepareData(momentDate)
            const req = axios({
                method: 'post',
                url: appConfig.baseUrl + '/turnover/storeDetails',
                data: data,
                headers: {
                    Authorization: userService.getAuthHeader()
                }
            });
            req.then(res => {
                onDataLoaded(res)
            }).catch(err => {
                this.items = []
                this.totalTurnover = 0
                console.log(err);
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/daily/Daily.vue